export default function ticketTemplateModelReducer(rawData) {
    const out = _.cloneDeep(rawData),
        fieldsToClean = [
            'id',
            'type',
            'created_at',
            'updated_at',
            'archived_at',
            'archived',
            'template_type'
        ];

    _.each(fieldsToClean, (field) => {
        if (!_.isUndefined(out[fieldsToClean])) {
            delete out[fieldsToClean];
        }
    })

    const mediaFields = [
        'background_image'
    ];

    _.each(mediaFields, (field) => {
        _.set(out, field, _.get(out, field + '.uuid', null));
    });

    return out;
}



// WEBPACK FOOTER //
// ./src/app/modules/tickets/templates/reducers/ticket-template-model-reducer.js